﻿package org.zq.astrock_ai.ui.research

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import org.zq.astrock_ai.api.dto.StaffRoles
import org.zq.astrock_ai.network.MarketApiClient
import org.zq.astrock_ai.ui.research.gushi.GushiTheme
import org.zq.astrock_ai.ui.research.gushi.StockWorkbenchApp
import org.zq.astrock_ai.ui.research.gushi.components.SmsLoginScreen
import org.zq.astrock_ai.ui.research.gushi.data.AuthSessionStore
import org.zq.astrock_ai.ui.research.gushi.data.DeviceLicenseStore

/**
 * 暂时关闭登录门禁，任何人可直接进入。改回 true 后恢复短信登录页（界面未删除）。
 */
private const val REQUIRE_LOGIN = false

/**
 * 「智启研究」入口：使用智启股势工作台界面。
 */
@Composable
fun StockResearchScreen(
    onBack: (() -> Unit)? = null,
) {
    var session by remember { mutableStateOf(AuthSessionStore.load()) }
    LaunchedEffect(session?.token) {
        val token = session?.token?.takeIf { it.isNotBlank() } ?: return@LaunchedEffect
        val me = runCatching { MarketApiClient().fetchAuthMe(token) }.getOrNull() ?: return@LaunchedEffect
        if (!me.ok) return@LaunchedEffect
        val current = session ?: return@LaunchedEffect
        val next = current.copy(
            phone = me.phone.ifBlank { current.phone },
            superAdmin = StaffRoles.isSuper(me.role, me.superAdmin),
            role = StaffRoles.normalize(me.role, me.superAdmin),
        )
        if (next != current) {
            AuthSessionStore.save(next)
            session = next
        }
    }
    GushiTheme {
        when {
            REQUIRE_LOGIN && session == null -> {
                SmsLoginScreen(
                    onLoggedIn = { next ->
                        AuthSessionStore.save(next)
                        session = next
                    },
                )
            }
            else -> {
                StockWorkbenchApp(
                    onBack = onBack,
                    loggedInPhone = session?.phone,
                    superAdmin = session?.superAdmin == true || session?.role == StaffRoles.SUPER,
                    staffRole = session?.role ?: StaffRoles.USER,
                    onLogout = {
                        val saved = DeviceLicenseStore.load()
                        if (saved?.plan == "trial" || saved?.token == "trial") {
                            DeviceLicenseStore.clearToken()
                        }
                        AuthSessionStore.clear()
                        session = null
                    },
                )
            }
        }
    }
}
